import { format } from 'date-fns'
import type { Money } from '@/types/shopify'

export const formatDateTime = (date?: Date | string, options: Intl.DateTimeFormatOptions = {}) => {
  if (!date) {
    return
  }
  date = new Date(date)
  options = {
    dateStyle: 'medium',
    ...options
  }
  return new Intl.DateTimeFormat('default', options).format(date).split('/').join('-')
}

export const formatYMD = (date: Date) => format(date, 'yyyy-MM-dd')

export const formatNumber = (number: number) => {
  return new Intl.NumberFormat('us-EN').format(number)
}

interface FormatCurrencyOptions {
  currency?: string
  stripZeros?: boolean
  multiplier?: number
}

export const formatCurrency = (amount: number | string, { stripZeros, currency, multiplier }: FormatCurrencyOptions = {}) => {
  if (typeof amount === 'string') {
    amount = parseFloat(amount)
  }
  const formatted = new Intl.NumberFormat('us-EN', {
    style: 'currency',
    currency: currency || 'USD',
    maximumFractionDigits: 2
  }).format(amount * (multiplier || 1))
  return stripZeros !== false ? formatted.replace('.00', '') : formatted
}

export const formatCents = (cents: number, options: FormatCurrencyOptions = {}) => formatCurrency(cents * 0.01, options)

export const formatMoney = (money: Money | undefined, options: FormatCurrencyOptions = {}) => {
  if (!money) {
    return
  }
  const { amount, currencyCode } = money
  return formatCurrency(amount, { currency: currencyCode, ...options })
}
